import { createApp, getCurrentInstance } from 'vue'

import {
  Button,
  Toast,
  SubmitBar
} from 'vant'

import 'vant/lib/index.css'
